<mat-icon inline *ngIf="backToUrl" (click)="navigateBack()">
  chevron_left
</mat-icon>

<h1>
  <ng-content></ng-content>
</h1>
